module.exports = __webpack_public_path__ + "img/divider.cb3e4b06.svg";